<!-- Updated -->
<script>
import * as m from '@app/paraglide/messages.js';
import { canEditMetadata } from '@app/store/permissionStore.svelte.js';
  /** @type {{event?: any, disabled?: boolean}} */
  let { event = $bindable({}), disabled = false } = $props();

    function markEvent() {
        if (disabled) {
            return;
        }
        event.forced = !event.forced;
    }
    </script>
{#if canEditMetadata("forced")}
<button
  id="forcedSubtitleBtn-{event.id}"
  type="button"
  class="btn btn-link text-decoration-none text-custom-medium {event.forced ? 'text-info fw-bold' : 'text-dark'}"
  onclick={() => markEvent()}
  {disabled}
  aria-disabled={disabled}
  aria-label={m.event_forced_aria_label()}
  title={m.event_forced_title()}>
    FS
</button>
{/if}

<style lang="css">
    button {
        padding : 2px;
        margin: 0;
    }
</style>
